window.addEventListener('DOMContentLoaded',()=>{
    let unoInfoDataObj = {
        unoCMFSwiper:"",
        unolineupSwiper:"",
        unoEmojisSwiper:"",
        ispcWidth:false,
        // gsap
        mobileFJval:768,
        innerHeight: window.innerHeight,
        // gsap end
        morefunBlackImgList:[],// 黑底
        morefunImgNum: 123,// 图片张数 -1
        morefunImgMap: new Map(), // 存储的是 1： img dom
        canvasMorefunDiv:document.getElementById("ug-uno-canvas-morefun"),
        canvasMorefunCtx:"",
        hasPreMorefunImg:false,
        morefunNowImgIndex:0, // 记录当前的 播放的index  滚动  canvas 异步加载img后采取进行 绘制 当获取好图片不在当前不在绘制只存储
        // emoji
        isEmojiFirstPlay:false,
        ispcWidthFn(){
            return window.innerWidth >=768 ? true : false;
        },
        showPreProPrice(){
            document.querySelectorAll('.ug-uno-lineup-item-price-pre').forEach((item,key)=>{
                let priceall = item.getAttribute('data-price');
                // 使用正则表达式和替换函数来格式化价格
                priceall = priceall.replace(/\d/, '?');
                item.innerHTML = priceall;
            });
        },
        init(){
            this.showPreProPrice();
            this.ispcWidth = this.ispcWidthFn();
            this.unolineupSwiperFn();
            if(this.canvasMorefunDiv){
                this.canvasMorefunCtx = this.canvasMorefunDiv.getContext("2d");
                this.morefunDrawImageFn(this.canvasMorefunDiv,this.canvasMorefunCtx,0);  // 提前放好第一帧
            }
            this.morefunDHWidthFn();
            if(this.ispcWidth){
                this.preGetMorefunImg();
                this.hasPreMorefunImg = true;
            }
            
            this.unoCMFSwiperFn();
            this.unoEmojisSwiperFn();

            this.adjustVideoSize();

            gsap.registerPlugin(ScrollTrigger);
            let mm = gsap.matchMedia();
            mm.add(`(min-width: ${this.mobileFJval}px)`, () => {
                // desktop setup code here...
                this.returnInnerHeight();
                this.gsapPCFn();
            });

            mm.add(`(max-width: ${this.mobileFJval - 1}px)`, () => {
                // mobile setup code here...
                this.returnInnerHeight();
                this.gsapMobileFn();
            });


            var resizeTimer = null;
            window.addEventListener("resize", ()=>{
                if(resizeTimer){
                    clearTimeout(resizeTimer);
                }
                resizeTimer = setTimeout(()=>{
                    this.morefunDHWidthFn();
                    if(unoInfoDataObj.ispcWidth != unoInfoDataObj.ispcWidthFn()){
                        unoInfoDataObj.ispcWidth = unoInfoDataObj.ispcWidthFn();
                        this.unolineupSwiperFn();
                    } 
                    if(this.ispcWidth && !this.hasPreMorefunImg){
                        this.preGetMorefunImg();
                        this.hasPreMorefunImg = true;
                    }
                    this.adjustVideoSize();
                    setTimeout(()=>{
                        //{% comment %} // 用于针对不同屏幕尺寸定义动画，并确保在屏幕尺寸变化时自动更新 {% endcomment %}
                        gsap.matchMediaRefresh();
                        //{% comment %} // 确保所有 ScrollTrigger 的起点和终点在窗口尺寸变化时正确刷新 {% endcomment %}
                        ScrollTrigger.refresh(); 
                    },0);
                },300);
            });

            // 打开全屏弹框视频
            document.querySelector('.ug-uno-videoCtrol-videobtndiv')?.addEventListener('click',()=>{
                document.querySelector('.ug-uno-maindivall .video_popup_box')?.classList.remove('dpn_important');
                unoInfoDataObj.videoPlayFn(document.querySelector('.ug-uno-video_popup_videpr'));
            });
            // 关闭弹框视频
            document.querySelector('.ug-uno-video_popup_closeFn')?.addEventListener('click',()=>{
                unoInfoDataObj.stopVideoPlayFn(document.querySelector('.ug-uno-video_popup_videpr'));
                document.querySelector('.ug-uno-maindivall .video_popup_box')?.classList.add('dpn_important');
            });
        },
        unoEmojisSwiperFn(){
            this. unoEmojisSwiper = new Swiper('.ug-uno-emojis-swiper',{
                direction: 'horizontal',
                threshold: 30, // 超过30px才算做滑动
                initialSlide: 2, // 从第几个开始
                slidesPerView: "auto",
                spaceBetween: 0,
                centeredSlides: true,
                loop:true,
                navigation: {
                    nextEl: '.ug-uno-emojis .ug-uno-emojis-swiper-control-r',
                    prevEl: '.ug-uno-emojis .ug-uno-emojis-swiper-control-l',
                },
                on:{
                    slideChangeTransitionEnd:function(event){
                        document.querySelectorAll('.ug-uno-emojis-title-small-p.active')?.forEach((item,k)=>{
                            item.classList.remove('active');
                        });
                        document.querySelectorAll('.ug-uno-emojis-title-small-p'+(event.realIndex + 1))?.forEach((item,k)=>{
                            item.classList.add('active');
                        });

                        document.querySelectorAll('.ug-uno-emojis .hasVideoPlay').forEach((item,key)=>{
                            item.pause();
                            item.currentTime = 0;
                        });
                        if(unoInfoDataObj.isEmojiFirstPlay){
                            unoInfoDataObj.unoEmojisSwiperVideoPlayFn();
                        }
                        
                    }
                }

            })
        },
        unoEmojisSwiperVideoPlayFn(){
            let video = document.querySelector('.ug-uno-emojis .swiper-slide-active video');
            video.play();
            video.classList.add('hasVideoPlay');
        },
        unolineupSwiperFn(){
            if(this.unolineupSwiper){
                this.unolineupSwiper.destroy(true,true);
            }
            if(this.ispcWidth){
                this.unolineupSwiper = new Swiper('.ug-uno-lineup-swiper', {
                    direction: 'horizontal',
                    threshold: 30, // 超过30px才算做滑动
                    initialSlide: 0,
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    navigation: {
                        nextEl: '.ug-uno-lineup-swiper .swiper-button-next',
                        prevEl: '.ug-uno-lineup-swiper .swiper-button-prev',
                    }
                });

            }else{
                this.unolineupSwiper = new Swiper('.ug-uno-lineup-swiper', {
                    direction: 'horizontal',
                    threshold: 30, // 超过30px才算做滑动
                    initialSlide: 0,
                    slidesPerView: 2, // 屏幕小于767px时，每个视图显示1个slide
                    spaceBetween: 10,
                    grid: {
                        rows: 2, // 屏幕小于767px时启用grid布局，设置为2行
                    },
                    pagination: {
                        el: ".ug-uno-lineup-swiper .swiper-pagination",
                        clickable: true,
                    }
                });
            }
        },
        unoCMFSwiperFn(){
            this.unoCMFSwiper = new Swiper('.ug-uno-cmf-swiper', {
                slidesPerView: 'auto',
                lazy: true,
                centeredSlides: true,
                spaceBetween: 0,
                resizeObserver:true,
                loop: true,  // slidesPerView
                effect: "coverflow",
                coverflowEffect: {
                    rotate: 40,
                    stretch: 20,
                    depth: 0,
                    modifier: 1,
                    slideShadows: false,
                    scale:0.8
                },
                navigation: {
                    nextEl: '.ug-uno-cmf-swiper .swiper-button-next',
                    prevEl: '.ug-uno-cmf-swiper .swiper-button-prev',
                },
                // breakpoints:{
                //     // when window width is >= 768px
                //     768: {
                //         spaceBetween: 0
                //     }
                // },
                on:{
                    slideChangeTransitionEnd:function(event){
                        console.log("event.realIndex",event.realIndex)
                        console.log("activeIndex",event.activeIndex)
                        document.querySelectorAll('.ug-uno-cmf-cont.active')?.forEach((item,k)=>{
                            item.classList.remove('active');
                        });
                        document.querySelectorAll('.ug-uno-cmf-cont'+(event.realIndex + 1))?.forEach((item,k)=>{
                            item.classList.add('active');
                        });
                    }
                }

            });

        },
        morefunDHWidthFn(){
            let dhw = 4000;
            let dhh = 2042;
            let pmw = window.innerWidth;
            let pmh = window.innerHeight;
            let canvasmodel = document.getElementById("ug-uno-canvas-morefun");

            let canvasNextDiv = document.querySelector(".ug-uno-canvas-nextdiv");
            let canvasNextDivMTop = 0;
            if((dhw / dhh) > (pmw / pmh) ){
                // 以宽为主
                canvasmodel.style.width = pmw + 'px';
                let canvasmodelHight = pmw * dhh / dhw
                canvasmodel.style.height = canvasmodelHight + 'px';

                canvasNextDivMTop = (pmh - canvasmodelHight) / 2 * (-1);
                document.querySelector('.ug-uno-morefundiv-w').style.marginTop = (-1) * (pmh - canvasmodelHight) / 2 + 'px';
            }else{
                canvasmodel.style.width = pmh * dhw / dhh + 'px';
                canvasmodel.style.height = pmh + 'px';
                document.querySelector('.ug-uno-morefundiv-w').style.marginTop = '0px';

                canvasNextDivMTop = 0;
            }
             // 设置 canvas 的实际宽度和高度
             canvasmodel.width = canvasmodel.clientWidth;
             canvasmodel.height = canvasmodel.clientHeight;

             //

            if(pmw < this.mobileFJval){
                canvasNextDivMTop = 0
            }
            if(canvasNextDiv){
                canvasNextDiv.style.marginTop = canvasNextDivMTop + 'px';
            }
            
        },
        preGetMorefunImg() {
            // 批次最大索引
            const maxIndex = 15;

            // 当前最大索引
            let nowMaxIndex = maxIndex;  // 第一次的队列就有 maxIndex张
        
            function loopGetImg() {
                if (nowMaxIndex < unoInfoDataObj.morefunImgNum) {
                    unoInfoDataObj.morefunLoadImage(nowMaxIndex, loopGetImg, true); // 每次加载图片队列 maxIndex 张
                    nowMaxIndex++;
                } else {
                    console.log(unoInfoDataObj.morefunImgMap);
                }
            }
        
            // 初始化加载前 15 张图片
            for (let i = 0; i < maxIndex; i++) {
                unoInfoDataObj.morefunLoadImage(i, loopGetImg);
            }
        },
        morefunLoadImage(imgNum, callback,isloopGetpic) {
            if(this.morefunImgMap.get(imgNum)){
                callback(this.morefunImgMap.get(imgNum));
            }else{
                const img = new Image();
                img.onload = () => {
                    unoInfoDataObj.morefunImgMap.set(imgNum,img);
                    console.log("img.onload",img);
                    if(isloopGetpic){ // 是否是循环获取图片时触发
                        callback(img);
                    }else{
                        if(unoInfoDataObj.morefunNowImgIndex == imgNum){
                            callback(img);
                        }else{
                            console.log("++++++++++++++++++++!!!!!!!!!!!!!!!!!!: 图片位置不匹配  不进行绘制")
                        }
                    }
                    
                };
                img.src = window.unoImgZDHData.morefunImgArray[imgNum] || '' ;
            }
        },
        morefunDrawImageFn(canvas,ctx,currentImageIndex) {
            console.log("drawImageFn",currentImageIndex)
            this.morefunLoadImage(currentImageIndex, (img) => {
                ctx.clearRect(0, 0, parseFloat(canvas.clientWidth), parseFloat(canvas.clientHeight));
                ctx.drawImage(img, 0, 0, parseFloat(canvas.clientWidth), parseFloat(canvas.clientHeight));
            });
        },
        returnInnerHeight(){
            this.innerHeight = window.innerHeight;
            this.zwHeight = window.innerHeight > 750 ? (window.innerHeight > 1000 ? 1000 : window.innerHeight) : 750;
        },
        gsapPCFn(){

            // 所有的操作都要在pin之后  不然定位会定不准
            // {% comment %} 公共 {% endcomment %}
            document.querySelectorAll(".ugos-gsap-pyjx-40px").forEach((item,key)=>{
                gsap.timeline({
                    scrollTrigger:{
                        trigger: item,
                        start:`top-=${this.innerHeight}px`,
                        end:`+=${this.zwHeight / 2 }px`,
                        scrub: 1 // 动画与滚动同步
                    }
                }).fromTo(item,{opacity:0,y:60},{opacity:1,y:0});
            });
            // 公共 end

            // 视频放大缩小
            this.videoControlGSAPFn();
            //视频放大缩小 end


            // morefun pc 帧动画
            // 渐显
            let morefundivhHalf = this.innerHeight / 2 - Math.max( 100, this.zwHeight / 4);
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-morefundiv',
                    start:`top-=${morefundivhHalf }px`,
                    end:`+=${ this.zwHeight / 4 }px`,
                    scrub: 1, // 动画与滚动同步
                }
            })
            .fromTo('.ug-uno-morefundivin',{opacity:0,y:60 },{opacity:1,y:0});

            let sjttToendnum = 20; // 手机开始抬头 到结束剩余的张数
            let morefuntqhzBL = sjttToendnum / (unoInfoDataObj.morefunImgNum + 1);//划走的比列
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-morefundiv',
                    start:`top top`,
                    end:`+=${800 * 4 * (1 - morefuntqhzBL)}px`,// 固定以笔记本的高为主
                    pin:true,
                    scrub: 1, // 动画与滚动同步
                }
            });
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-morefundiv',
                    start:`top top`,
                    end:`+=${800 * 4 }px`,  // 固定以笔记本的高为主
                    scrub: 1, // 动画与滚动同步
                    onUpdate: (self) => {
                        // self.progress 表示滚动的百分比 0-1
                        const frameIndex = Math.min(
                            unoInfoDataObj.morefunImgNum,
                            Math.floor(self.progress * unoInfoDataObj.morefunImgNum)
                        );
                        console.log('frameIndex',frameIndex)
                        unoInfoDataObj.morefunNowImgIndex = frameIndex;
                        requestAnimationFrame(() => unoInfoDataObj.morefunDrawImageFn(unoInfoDataObj.canvasMorefunDiv,
                                                                                    unoInfoDataObj.canvasMorefunCtx,
                                                                                    frameIndex));
                    }
                }
            });

            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-morefundiv-w',
                    start:`top+=${800 * 4 * (1 - morefuntqhzBL)  - this.zwHeight / 3}px`,// 固定以笔记本的高为主
                    end:`+=${this.zwHeight / 4}px`,
                    scrub: 1 // 动画与滚动同步
                }
            })
            // .addLabel('morefuntitle') // 将当前函数命名为 morefuntitle;
            .fromTo('.ug-uno-morefunContab',{opacity:0},{opacity:1})
            .fromTo(".ug-uno-morefunContab .ug-uno-emojis-titlediv h2",
                    { y:'60px',opacity:0 },
                    { y:0,opacity:1 },
                    '<'// 同时开始
            )
            .fromTo(".ug-uno-morefunContab .ug-uno-emojis-titlediv p",
                    { y:'60px',opacity:0 },
                    { y:0,opacity:1 }
            )
            .to(".ug-uno-morefunContab",
                    { zIndex:0 }
            );
            // morefun pc 帧动画 end

            // emoji 视频播放
            let emojiwkh = document.querySelector('.ug-uno-emojis-swiper-wkdiv').clientWidth * 0.974
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-emojis-swiper-wkdiv',
                    start:`top-=${(this.innerHeight - emojiwkh)}px`,
                    end:`+=${this.innerHeight}px`,
                    scrub: 1, // 动画与滚动同步
                    onEnter:()=>{
                        if(!unoInfoDataObj.isEmojiFirstPlay){
                            unoInfoDataObj.unoEmojisSwiperVideoPlayFn();
                            unoInfoDataObj.isEmojiFirstPlay = true;
                        }
                    },
                    onEnterBack:()=>{
                        if(!unoInfoDataObj.isEmojiFirstPlay){
                            unoInfoDataObj.unoEmojisSwiperVideoPlayFn();
                            unoInfoDataObj.isEmojiFirstPlay = true
                        }
                    }
                }
            });
            // emoji 视频播放 end
        },
        gsapMobileFn(){
            //{% comment %} 公共 {% endcomment %}
            document.querySelectorAll(".ugos-gsap-mobile-pyjx-40px").forEach((item,key)=>{
                gsap.timeline({
                    scrollTrigger:{
                        trigger: item,
                        start:`top-=${this.innerHeight}px`,
                        end:`+=${this.zwHeight / 2 }px`,
                        scrub: 1 // 动画与滚动同步
                    }
                }).fromTo(item,{opacity:0,y:60},{opacity:1,y:0});
            });
            // 公共 end

            // 视频放大缩小
            this.videoControlGSAPFn();
            // 视频放大缩小 end

            // morefun mb 视频播放
            let morefunvideoh = document.querySelector('.ug-uno-morefun-videoprdiv').clientHeight;
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-morefun-videoprdiv',
                    start:`top-=${(this.innerHeight - morefunvideoh)}px`,
                    end:`+=${this.innerHeight}px`,
                    scrub: 1, // 动画与滚动同步
                    onEnter:()=>{
                        if(document.querySelector('.ug-uno-morefun-videopr video').paused){
                            document.querySelector('.ug-uno-morefun-videopr video').play();
                        }
                    },
                    onLeave:()=>{
                        if(!document.querySelector('.ug-uno-morefun-videopr video').paused){
                            document.querySelector('.ug-uno-morefun-videopr video').pause();
                            document.querySelector('.ug-uno-morefun-videopr video').currentTime = 0;
                        }
                    },
                    onUpdate: (self) => {
                        if(self.progress>0.2 && self.progress <= 0.5 && document.querySelector('.ug-uno-morefun-videopr video').paused){
                            document.querySelector('.ug-uno-morefun-videopr video').play();
                        }
                    }
                }
            });
            // 向上返回暂停
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-morefun-videoprdiv',
                    start:`top-=${(this.innerHeight * 2)}px`,
                    end:`+=${this.innerHeight}px`,
                    scrub: 1, // 动画与滚动同步
                    onLeaveBack:()=>{
                        if(!document.querySelector('.ug-uno-morefun-videopr video').paused){
                            document.querySelector('.ug-uno-morefun-videopr video').pause();
                            document.querySelector('.ug-uno-morefun-videopr video').currentTime = 0;
                        }
                    }
                }
            });
            // morefun mb 视频播放 end

            // emoji 视频播放
            let emojiwkh = document.querySelector('.ug-uno-emojis-swiper-wkdiv').clientWidth * 0.974
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-emojis-swiper-wkdiv',
                    start:`top-=${(this.innerHeight - emojiwkh)}px`,
                    end:`+=${this.innerHeight}px`,
                    scrub: 1, // 动画与滚动同步
                    onEnter:()=>{
                        if(!unoInfoDataObj.isEmojiFirstPlay){
                            unoInfoDataObj.unoEmojisSwiperVideoPlayFn();
                            unoInfoDataObj.isEmojiFirstPlay = true;
                        }
                    },
                    onEnterBack:()=>{
                        if(!unoInfoDataObj.isEmojiFirstPlay){
                            unoInfoDataObj.unoEmojisSwiperVideoPlayFn();
                            unoInfoDataObj.isEmojiFirstPlay = true
                        }
                    }
                }
             });
             // emoji 视频播放 end
        },
        videoPlayFn(item){
            let activeModel = item?.getAttribute('data-model');
            if(!activeModel){
              return false;
            }
            if(activeModel == 'shopifyvideo'){
                let video = item.querySelector('video');
                video.play();
                video.classList.add('hasVideoPlay');
            }else if(activeModel == 'youtube'){
                let video = item.querySelector('.youtube');
                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                video.classList.add('hasVideoPlay');
            }else if(activeModel == 'js-vimeo'){
                let video = item.querySelector('.js-vimeo');
                video.contentWindow.postMessage('{"method":"play"}', '*'); 
                video.classList.add('hasVideoPlay');
            }
        },
        stopVideoPlayFn(itemDome){
            let item = itemDome.querySelector('.hasVideoPlay');
            if(!item){
              return false;
            }
            if(item.classList.value.indexOf('shopifyvideo')!=-1){
              item.pause();
              item.currentTime = 0;
            }else if(item.classList.value.indexOf('js-youtube')!=-1){
                item.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                item.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0,true]}', '*');
            }else if(item.classList.value.indexOf('js-vimeo')!=-1){
                item.contentWindow.postMessage('{"method":"pause"}', '*');
                item.contentWindow.postMessage('{"method":"setCurrentTime", "value":0}', '*');
            }
            item.classList.remove('hasVideoPlay');
        },
        videoControlGSAPFn(){
            // 视频放大缩小 gsap 动画
            let videoCtrolWordtbBL = 0.68338;   // 文字出现 开始进行动画的 边界 比例
            let videoCtrolcountjl = Math.floor(document.querySelector(".ug-uno-videoCtrol-wzprwidth")?.clientHeight * videoCtrolWordtbBL - document.querySelector(".ug-uno-videoCtrol-wzprwidth").clientHeight / 2);
            // 渐变出视频
            gsap.timeline({
                    scrollTrigger:{
                        trigger: '.ug-uno-videoCtrolpr',
                        start:`top-=${ this.innerHeight / 2 + videoCtrolcountjl - Math.min(this.innerHeight / 5, 150)}px`,
                        end:`+=${ this.innerHeight / 2 + videoCtrolcountjl - Math.min(this.innerHeight / 5, 150)}px`,
                        scrub: 1, // 动画与滚动同步
                    }
            }).fromTo('.ug-uno-videoCtrol-hszz',{opacity:1 },{opacity:0});

            let videoAnimateJJ = 800;

            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-videoCtrolpr',
                    start:`top top`,
                    end:`+=${ videoAnimateJJ + 300 - 100 }px`, // 多加一屏幕
                    scrub: 1, // 动画与滚动同步
                    pin:true
                }
            });

            // 视频播放、暂停
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-videoCtrolpr',
                    start:`top top`,
                    end:`+=${ this.innerHeight + videoAnimateJJ + 300 - 100 }px`, // 多加一屏幕
                    scrub: 1, // 动画与滚动同步
                    // markers:true,
                    onToggle:(self)=>{
                        console.log("%%%%%%%%%%%",self);
                        if(self.isActive){
                            // 视口
                            if(document.querySelector('.ug-uno-videoCtrolpr video').classList.value.indexOf('hasVideoPlay')==-1){
                                unoInfoDataObj.videoPlayFn(document.querySelector('.ug-uno-videoCtrolpr'));
                                console.log("!!!!!!!!!!","videoPlayFn")
                            }
                        }else{
                           // 不在视口
                           if(document.querySelector('.ug-uno-videoCtrolpr video').classList.value.indexOf('hasVideoPlay')!=-1){
                                unoInfoDataObj.stopVideoPlayFn(document.querySelector('.ug-uno-videoCtrolpr'));
                                console.log("!!!!!!!!!!","stopVideoPlayFn")
                            }
                        }
                    }
                }
            })

            
            // 动画 以父级为准
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-videoCtrol',
                    start:`top top`,
                    end:`+=${videoAnimateJJ}px`,
                    scrub: 1, // 动画与滚动同步
                    // markers:true,
                }
            }).fromTo('.ug-uno-videoCtrol-wzpr',{scale: 1},{scale: 10 })

            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-videoCtrol',
                    start:`top+=${videoAnimateJJ / 2}px`,
                    end:`+=${videoAnimateJJ / 2}px`, 
                    scrub: 1, // 动画与滚动同步
                    // markers:true,
                }
            })
            .fromTo('.ug-uno-videoCtrol-wzpr',{opacity: 1 },{opacity: 0 })
            

            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-videoCtrol',
                    start:`top+=${ videoAnimateJJ - 200}px`,
                    end:`+=100px`, 
                    scrub: 1, // 动画与滚动同步
                    // markers:true,
                }
            })
            .fromTo('.ug-uno-videoCtrol-videobtndiv',{zIndex:-1 },{zIndex:0 })

            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-uno-videoCtrol',
                    start:`top+=${ videoAnimateJJ - 100}px`,
                    end:`+=300px`, 
                    scrub: 1, // 动画与滚动同步
                    // markers:true,
                }
            })
            .fromTo('.ug-uno-videoCtrol-videobtndiv',{opacity:0 },{opacity:1 })
        },
        adjustVideoSize() {
            let container = document.querySelector('.ug-uno-bannercontentdiv');
            let video = document.querySelector('.ug-uno-bannercontentdiv video');
            let containerRatio = container.clientWidth / container.clientHeight;
            let videoRatio = video.videoWidth / video.videoHeight;
            
            if (containerRatio > videoRatio) {
                video.style.width = 'calc(100% + 2px)';
                video.style.height = 'auto';
            } else {
                video.style.width = 'auto';
                video.style.height = 'calc(100% + 2px)';
            }
        }

    }

    window.test = unoInfoDataObj
    unoInfoDataObj.init();

});